import { render, staticRenderFns } from "./WRCLink.vue?vue&type=template&id=5889d4a4&scoped=true&"
import script from "./WRCLink.vue?vue&type=script&lang=js&"
export * from "./WRCLink.vue?vue&type=script&lang=js&"
import style0 from "./WRCLink.vue?vue&type=style&index=0&id=5889d4a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889d4a4",
  null
  
)

export default component.exports